import {
  IBetsResponse,
  IGameBetsResponse,
  ILiveBetsResponse,
  ILiveWinsResponse,
  IMyBetsResponse,
} from '@/types'

import { api } from '.'

export async function getBets(): Promise<IBetsResponse>
export async function getBets(game: string): Promise<IGameBetsResponse>
export async function getBets(
  game?: string
): Promise<IBetsResponse | IGameBetsResponse> {
  const { data } = await api.get(game ? `/game/bets/${game}` : '/game/bets')

  return data
}

export async function getMyBets(): Promise<IMyBetsResponse> {
  const { data } = await api.get<IMyBetsResponse>(`/game/myBets`)

  return data
}

export async function getLiveBets(): Promise<ILiveBetsResponse> {
  const { data } = await api.get<ILiveBetsResponse>(`/game/liveBets`)

  return data
}

export async function getLiveWins(): Promise<ILiveWinsResponse> {
  const { data } = await api.get<ILiveWinsResponse>(`/game/history/wins`)

  return data
}
